import { AdminTheme } from '../theme';
import { VitegoAppIcon } from '../../../components/VitegoAppIcon';

export function AdminLoadingPage({ theme }: { theme: AdminTheme }) {
  return (
    <main className="admin-auth-page" data-palette="vitego" data-theme={theme}>
      <section className="admin-auth-card admin-auth-card_compact" aria-label="Проверка доступа">
        <div className="admin-auth-brand">
          <span className="admin-auth-brand__mark"><VitegoAppIcon /></span>
          <span>
            <strong>Vitego</strong>
            <small>Администрирование</small>
          </span>
        </div>
        <p className="admin-eyebrow">Управление</p>
        <h1>Проверяем доступ</h1>
        <p className="admin-caption">Проверяем доступ.</p>
      </section>
    </main>
  );
}
